import { Collapse as AntdCollapse } from 'antd';
import styled from 'styled-components';

import Colors from '@rockalingua/ui/constants/Colors';
import { variantStyles as textVariantStyles } from '../Typography/Text.styled';

export const StyledCollapse = styled(AntdCollapse)`
  width: 100%;
  background-color: transparent;
`;

export const StyledPanel = styled(AntdCollapse.Panel)`
  margin-bottom: 16px;
  border: 1px solid ${Colors.MAIN_VARIANTS[30]} !important;
  background-color: white;
  border-radius: 16px !important;
  padding-bottom: 24px;

  .ant-collapse-header {
    padding: 24px 24px 0 !important;
    .ant-collapse-header-text {
      ${textVariantStyles['grey-18-bold']}
      max-width: calc(100% - 40px);
    }
  }

  .ant-collapse-content > .ant-collapse-content-box {
    padding: 8px 24px 0px 24px !important;
  }

  &.ant-collapse-item-active {
    border-color: ${Colors.MAIN_VARIANTS[60]} !important;
    background-color: ${Colors.MAIN_VARIANTS[10]};
  }

  ul {
    list-style-type: disc;
    margin-bottom: 0;
    li {
      margin-bottom: 8px;
    }
  }

  strong {
    ${textVariantStyles['grey-16-bold']}
  }
`;

export const IconContainer = styled.div`
  background-color: white;
  border: 1px solid ${Colors.BLUE};
  border-radius: 50%;
  top: 34px !important;
  right: 20px !important;
  width: 32px;
  height: 32px;
  display: flex !important;
  align-items: center;
  justify-content: center;
  position: relative;

  svg {
    display: flex;
    color: ${Colors.BLUE};
  }
`;

export const PanelContent = styled.div`
  ${textVariantStyles['grey-16-medium']}
  color: ${Colors.BLACK};
`;
